import { Directive, AfterViewInit, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appAutofocus]'
})
export class AutofocusDirective implements AfterViewInit {

  @Input() autoFocusOn: boolean = true;
  
  constructor(private el: ElementRef) {
  }
  
  ngAfterViewInit() {
    if(this.autoFocusOn) {
      this.el.nativeElement.focus();
    }
  }
  
}